import DefaultFonts from './fonts';
import DefaultColors from './colors';
const DefaultTheme = {
  colors: DefaultColors,
  fonts: DefaultFonts
};
export default DefaultTheme;
//# sourceMappingURL=DefaultTheme.js.map